import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import removeWatchdogs1 from "../../assets/img/docs/watchdog-4.png"; // ✅ adjust path to match your assets

const RemoveWatchdogs = () => {
  const { t } = useTranslation();

  return (
    <Container fluid className="py-5 remove-watchdogs-docs">
      <Row className="justify-content-center mb-4">
        <Col lg={8}>
          <Card className="shadow-sm border-0 rounded-lg p-4">
            <Card.Body>
              {/* Title */}
              <Card.Title className="display-6 mb-3">
                {t("documentation.watchdog.removeAll.title")}
              </Card.Title>

              {/* Description */}
              <Card.Text className="text-muted mb-3">
                {t("documentation.watchdog.removeAll.description")}
              </Card.Text>

              <p className="mb-3 text-muted">
                {t("documentation.watchdog.removeAll.howToAccess")}
              </p>

              <Row className="g-3 mb-4">
                <Col md={12}>
                  <Image
                    src={removeWatchdogs1}
                    alt="Remove All Watchdogs - How to Access"
                    className="doc-image shadow-sm"
                    rounded
                    fluid
                  />
                </Col>
              </Row>

              {/* Details */}
              <h5 className="fw-semibold mt-4 mb-2">
                {t("documentation.watchdog.removeAll.details.title")}
              </h5>
              <ul className="overview-list mb-3">
                <li>
                  {t(
                    "documentation.watchdog.removeAll.details.immediateEffect"
                  )}
                </li>
                <li>
                  {t("documentation.watchdog.removeAll.details.noAlerts")}
                </li>
                <li>
                  {t("documentation.watchdog.removeAll.details.cleanSlate")}
                </li>
              </ul>

              {/* Use Cases */}
              <h5 className="fw-semibold mt-4 mb-2">
                {t("documentation.watchdog.removeAll.useCases.title")}
              </h5>
              <ul className="overview-list mb-3">
                <li>
                  {t("documentation.watchdog.removeAll.useCases.policyChanges")}
                </li>
                <li>
                  {t("documentation.watchdog.removeAll.useCases.testing")}
                </li>
                <li>
                  {t("documentation.watchdog.removeAll.useCases.errorRecovery")}
                </li>
              </ul>

              {/* Considerations */}
              <h5 className="fw-semibold mt-4 mb-2">
                {t("documentation.watchdog.removeAll.considerations.title")}
              </h5>
              <ul className="overview-list">
                <li>
                  {t(
                    "documentation.watchdog.removeAll.considerations.irreversible"
                  )}
                </li>
                <li>
                  {t(
                    "documentation.watchdog.removeAll.considerations.criticalMonitoring"
                  )}
                </li>
                <li>
                  {t(
                    "documentation.watchdog.removeAll.considerations.bulkOperations"
                  )}
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RemoveWatchdogs;
